import React from "react";

function formatTypeWithLink(cell) {
	let typeValue = cell.getValue();
	let rowData = cell.getRow().getData();
	let urlValue = rowData.url;
	let typeDisplay = typeValue || "";
	let linkDisplay = "";
	if (urlValue != null && urlValue != "") {
		linkDisplay = " <a target='_blank' href='" + urlValue + "'><i title='item link' class='fa fa-external-link' aria-hidden='true'></i></a>";
	}
	return typeDisplay + linkDisplay;
}

function formatImportantNotes(cell) {
	let value = cell.getValue();
	//at a later date when/if this grows I need to do some sort of if else if and chain together and build the div I wish to return to maintain only a single return
	//for now im coding to acomodate the two situations that can occur.
	if (value == null) {
		return;
	}
	if (value != null) {
		if (
			value.includes("DO NOT STOCK") &&
			value.includes("(SPECIAL CONNECTOR REQUIRED")
		) {
			let val = value.replace(
				"DO NOT STOCK - ORDER PER JOB (SPECIAL CONNECTOR REQUIRED",
				""
			);
			var title = "SPECIAL CONNECTOR REQUIRED " + val;
			return (
				"<i style='color: 'red';' title='DO NOT STOCK - ORDER PER JOB' class='fa fa-window-close noStock' aria-hidden='true'></i><i style='color: 'red';' title='" +
				title +
				"' class='fa fa-link connector' aria-hidden='true'></i>"
			);
		}
		if (value.includes("DO NOT STOCK")) {
			let val = value.replace("DO NOT STOCK - ORDER PER JOB", "");
			return "<i style='color: 'red';' title='DO NOT STOCK - ORDER PER JOB' class='fa fa-window-close noStock' aria-hidden='true'></i>";
		}
		if (value.includes("NOT FOR VIDEO TRANSMISSION")) {
			return "<i style='color: 'orange';' title='Not For Video Transmission'  class='fa fa-eye-slash'></i>";
		}
	}
	return <div>{value}</div>;
}

// Function to build tab columns with different stock level fields
export function buildTabColumns(stockLevelField, currencySymbol = "$") {
	return [
		{
			title: "Type",
			field: "typeOfEquipment",
			headerFilter: "input",
			formatter: formatTypeWithLink,
		},
		{
			title: "Description",
			field: "description",
			headerFilter: "input",
		},
		{
			title: "Imp. Notes",
			field: "importantNotes",
			formatter: formatImportantNotes,
		},
		{
			title: "Old Part Number",
			field: "oldPartNumber",
			headerFilter: "input",
			hozAlign: "right",
		},
		{
			title: "Part Number",
			field: "newPartNumber",
			headerFilter: "input",
			hozAlign: "right",
		},
		{
			title: "Cost",
			field: "cost",
			formatter: "money",
			formatterParams: { symbol: currencySymbol },
			hozAlign: "right",
		},
		{
			title: "Measure",
			field: "unitOfMeasure",
		},
		{
			field: stockLevelField,
			title: "Stock lvl",
			hozAlign: "right",
		},
		{
			title: "To Order",
			field: "quantity",
			editor: "input",
			hozAlign: "right",
		},
	];
}

export const tabMediumColumns = buildTabColumns("mediumDesiredQuantity");

export const tabSmallColumns = buildTabColumns("smallDesiredQuantity");

export const tabLargeColumns = buildTabColumns("largeDesiredQuantity");

export const tabJobColumns = buildTabColumns("")
	.filter((column) => column.title !== "Stock lvl")
	.map((column) => {
		// Add width constraints only for job page to prevent infinite expansion
		const widthMap = {
			"Type": 150,
			"Description": 300,
			"Imp. Notes": 80,
			"Old Part Number": 150,
			"Part Number": 150,
			"Cost": 100,
			"Measure": 80,
			"To Order": 100,
		};
		return {
			...column,
			width: widthMap[column.title] || undefined,
		};
	});

export const tabEngColumns = buildTabColumns("")
	.filter((column) => column.title !== "Stock lvl")
	.map((column) => {
		const editableProps = { editor: "input", editable: true };
		// Don't add editable to Notes column, just update title
		if (column.title === "Imp. Notes") {
			return { ...column};
		}
		// Add editable to all other columns
		return { ...column, ...editableProps };
	});

// LON (UK) columns - no stock level, renamed to match UK SharePoint list
export const tabLonColumns = [
	{
		title: "UK Category",
		field: "typeOfEquipment",
		headerFilter: "select",
		headerFilterParams: { values: true },
	},
	{
		title: "UK Part Code",
		field: "oldPartNumber",
		headerFilter: "input",
		hozAlign: "right",
	},
	{
		title: "Description",
		field: "description",
		width: 500,
		headerFilter: "input",
	},
		{
		title: "Imp. Notes",
		field: "importantNotes",
	},
	{
		title: "General Notes",
		field: "notes",
	},
	{
		title: "Package Size",
		field: "unitOfMeasure",
		width: 110,
		hozAlign: "center",
	},
	{
		title: "UK Price",
		field: "cost",
		width: 90,
		formatter: "money",
		formatterParams: { symbol: "\u00a3" },
		hozAlign: "right",
	},
	{
		title: "Links",
		field: "url",
		width: 60,
		hozAlign: "center",
		formatter: function(cell) {
			let urlValue = cell.getValue();
			if (urlValue) {
				return "<a target='_blank' href='" + urlValue + "'><i title='item link' class='fa fa-external-link' aria-hidden='true'></i></a>";
			}
			return "";
		},
	},
	{
		title: "To Order",
		field: "quantity",
		editor: "input",
		hozAlign: "right",
	},
];
